export enum ETextareaStyleType {
  Primary = "primary",
  Secondary = "secondary",
}
